const devKeys = {
  valid: ['f930db26da5747f78c48bec5f3ac0a52e941cd150b366bafeedd5f1501d314e5', 'PissWasser', 'LuftWaffe'],
  revoked: [],
}

// Below function allows to check for a ?dev=<valid key> param at the URL
// And if it is found - returns true; used to expose debug features that normally should be hidden
// Thanks, all of you kind mobile web3 dapp browsers
export function UsingDevKey() {
  const queryParams = new URLSearchParams(window.location.search);
  let devKey = queryParams.get('dev');
  if (devKeys.valid.includes(devKey)) {
    return true;
  } else {
    return false;
  }
}